import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { HttpHeaders } from '@angular/common/http'
import { map, mergeMap, Observable } from 'rxjs';
import { ApolloQueryResult } from '@apollo/client/core';
import { GraphPaymentIntentResult } from '../../../models/paymentIntent/paymentIntent.interface'

@Injectable({
  providedIn: 'root',
})
export class PaymentIntentsService {

  constructor(private apollo: Apollo,) { }

  public queryPaymentIntent(): Observable<any> {

    const authToken = localStorage.getItem('auth.access_token');

    const headers = new HttpHeaders().set('Authorization', `Bearer ${authToken}`);

    return this.apollo
      .query({
        query: gql`
          query PaymentIntents($merchantId: String!, $createdAtFrom: String!, $createdAtTo: String!, $timeZone: String!) {
            paymentIntents(
              merchant_id: $merchantId
              created_at_from: $createdAtFrom
              created_at_to: $createdAtTo
              time_zone: $timeZone
            ) {
              items {
                id
                amount
                type
                bin
                lastfourdigit
                network
                status
                operation_type
                operation_number
                updated_at
                channel
                created_at_time_zone
                updated_at_time_zone
              }
            }
          }
        `,
        variables: {
          merchantId: localStorage.getItem('auth.merchant_id'),
          createdAtFrom: localStorage.getItem('calendar.created_at_from').replace('Z', ''),
          createdAtTo: localStorage.getItem('calendar.created_at_to').replace('Z', ''),
          timeZone: localStorage.getItem('auth.time_zone'),
        },
        context: {
          headers: headers,
        },
        fetchPolicy: 'network-only',
      })
  }

  public queryPaymentIntentDetail(paymentId: string): Observable<any> {

    const authToken = localStorage.getItem('auth.access_token');

    const headers = new HttpHeaders().set('Authorization', `Bearer ${authToken}`);

    return this.apollo
      .query({
        query: gql`
          query PaymentIntents($merchantId: String!, $transactionId: String!, $timeZone: String!) {
            paymentIntentDetail(
              id: $transactionId
              time_zone: $timeZone
              merchant_id: $merchantId
            ){
              amount
              authorization_code
              network
              bin
              lastfourdigit
              operation_type
              created_at
              created_at_time_zone
              expired_at
              updated_at
              updated_at_time_zone
              mode
              order_number
              currency
              status
              type
              description
              source
              id
              threeds_specificationVersion
              threeds_eci
              threeds_acceptRisk
              channel
              operation_number
              deposit_date
              total_commissions
              final_amount
              terminal_type
              terminalcheckout_id
              onlinecheckout_id
              geolocation
              refunded_amount
              installment_count
              total_taxes
              serial_number
              deposit_amount
              metadata
              merchant_name
              has_reversal
              merchant_id
              bsk_device_alias
              software_version
              paymentintent_parent_id
              status_code
		          status_code_description
              current_installment_number
              card_installment_type
              payment_method_option_card_installment_amount
            }
          }
        `,
        variables: {
          merchantId: localStorage.getItem('auth.merchant_id'),
          transactionId: paymentId,
          timeZone: localStorage.getItem('auth.time_zone'),
        },
        context: {
          headers: headers,
        },
        fetchPolicy: 'network-only',
      }).pipe(
        map((result: ApolloQueryResult<any> ) => {
          if(result.data && result.data.paymentIntentDetail) {
            // forzar que current_installment_number y payment_method_option_card_installment_amount siempre tenga un valor(0)
            let { current_installment_number, payment_method_option_card_installment_amount } = result.data?.paymentIntentDetail;

            if(current_installment_number === undefined || current_installment_number === null) {
              console.error('current_installment_number undefined or null');
              current_installment_number = 0;
            }

            if(payment_method_option_card_installment_amount === undefined || payment_method_option_card_installment_amount === null) {
              console.error('payment_method_option_card_installment_amount undefined or null');
              payment_method_option_card_installment_amount = 0;
            }

            // no se puede hacer directo en el objeto xq esta en read-only o freeze
            // por lo que retornamos nuevo objeto "clonado" con las nuevas propiedades
            return {
            ...result,
              data: {
                ...result.data,
                paymentIntentDetail: {
                  ...result.data.paymentIntentDetail,
                  current_installment_number,
                  payment_method_option_card_installment_amount,
                }
              }
            }
          } else {
            return result;
          }
        })
      )
  }
}
